import { isOfType } from 'typesafe-actions';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { VALIDATE_CLAIM_DATA } from '../../../../reducers/types';
import {
    clearClaimInfoLinkList,
    incrementValidationErrorCounter,
    setClaimInfoLinkList,
    setErrorMessage,
    setLoadingModalFlagAction,
} from '../../../../reducers/actions';
import {
    ClearClaimInfoLinkListAction,
    SetClaimInfoLinkListAction,
    SetErrorMessageAction,
    SetLoadingModalFlagAction,
    ValidationAction,
} from '../../../../reducers';
import { buildClaimInfoLinkList } from '../../converters/buildClaimInfoLinkList';
import { fetchValidation } from './fetchValidation';

const validateClaimDataEpic = (
    action$: Observable<ValidationAction>,
): Observable<
    SetClaimInfoLinkListAction | SetLoadingModalFlagAction | SetErrorMessageAction | ClearClaimInfoLinkListAction
> =>
    action$.pipe(
        filter(isOfType(VALIDATE_CLAIM_DATA)),
        mergeMap(({ payload }: ValidationAction) =>
            fetchValidation(payload).pipe(
                map(buildClaimInfoLinkList),
                mergeMap((claimInfoLinks: ClaimInfoLink[]) =>
                    of(setClaimInfoLinkList(claimInfoLinks), setErrorMessage('')),
                ),
                catchError((error: Error) =>
                    of(
                        setLoadingModalFlagAction(false),
                        clearClaimInfoLinkList(),
                        setErrorMessage(error.message),
                        incrementValidationErrorCounter(),
                    ),
                ),
            ),
        ),
    );

export default validateClaimDataEpic;
